import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WorkItemLens } from 'common/workitems/models/workitem-lens';

@Component({
  selector: 'app-lens-widget',
  templateUrl: './lens-widget.component.html',
  styleUrls: ['./lens-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LensWidgetComponent {
  @Input()
  workItem: WorkItemLens;
}
